import { render } from "./image_multi.vue?vue&type=template&id=7bc07c4c"
import script from "./image_multi.vue?vue&type=script&lang=js"
export * from "./image_multi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/image_multi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bc07c4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bc07c4c', __exports__)) {
    api.reload('7bc07c4c', __exports__)
  }
  
  module.hot.accept("./image_multi.vue?vue&type=template&id=7bc07c4c", () => {
    api.rerender('7bc07c4c', render)
  })

}


export default __exports__